import { render } from "./mainLobbyPage.vue?vue&type=template&id=12673591&scoped=true"
import script from "./mainLobbyPage.vue?vue&type=script&lang=js"
export * from "./mainLobbyPage.vue?vue&type=script&lang=js"

import "./mainLobbyPage.vue?vue&type=style&index=0&id=12673591&scoped=true&lang=css"

import exportComponent from "/tmp/build_b726cccb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12673591"]])

export default __exports__